import { render, staticRenderFns } from "./kementriandanlembaga.vue?vue&type=template&id=59ebca4e"
import script from "./kementriandanlembaga.vue?vue&type=script&lang=js"
export * from "./kementriandanlembaga.vue?vue&type=script&lang=js"
import style0 from "./kementriandanlembaga.vue?vue&type=style&index=0&id=59ebca4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports